import '../applied_numeric_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedFollowersCountView extends Monitoring.Views.SocialContents.Filters.AppliedNumericView
  name: 'max_followers'
  fieldName: 'followers'

  initialize: ({searchQuery}) ->
    super(
      searchQuery: searchQuery
      title: I18n.t('monitoring.dashboard.filters.filter_names.followers_count')
    )
